// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-b7a23f08]{list-style-type:none}.d-flex[data-v-b7a23f08]{display:contents!important}ul[data-v-b7a23f08]{-webkit-padding-start:0!important;padding-inline-start:0!important}.dropdown-content[data-v-b7a23f08]{right:0!important;left:auto!important}.dropdown-divider[data-v-b7a23f08]{opacity:.5}", ""]);
// Exports
module.exports = exports;
